import { Linking } from 'react-native';

export default {
  openBrowserAsync: Linking.openURL,
};



// WEBPACK FOOTER //
// ./src/@ui/WebBrowser/index.web.js